export default "__VITE_ASSET__CwuuAACZ__"